import { type ReactElement } from 'react'
import { type RpOccurrence } from '../../../../../../../[id]/rp-occurrence/rpOccurrenceProxy'
import { usdFormatter } from '../../../../../../../../../../shared/utils/formattingUtils'

interface AmountCellProps {
  rpOccurrence: RpOccurrence
}
export function RpOccurrenceOriginalAmountCell ({ rpOccurrence }: AmountCellProps): ReactElement {
  const formattedValue = usdFormatter.format(rpOccurrence.amountCents)

  return (
    <td
      className="px-3 py-1"
    >
      {formattedValue}
    </td>
  )
}
